import { useState } from 'react';
import { SUBJECTS, searchSubjects } from '../../../config/subjects';

function SubjectSelectorStyles() {
  return (
    <style>{`
      .selector-wrap {
        flex: 1;
        overflow-y: auto;
        padding: 64px 32px 48px;
        position: relative;
        z-index: 1;
      }
      .selector-col { width: 100%; max-width: 760px; margin: 0 auto; }

      .selector-eyebrow {
        font-family: var(--font-mono);
        font-size: 0.7rem; letter-spacing: 0.2em; text-transform: uppercase;
        color: var(--gilt); margin-bottom: 14px;
      }
      .selector-title {
        font-family: var(--font-display);
        font-optical-sizing: auto;
        font-size: clamp(2.3rem, 5vw, 3.4rem);
        font-weight: 500;
        color: var(--vellum);
        letter-spacing: 0.005em;
        line-height: 1.05;
        margin-bottom: 12px;
      }
      .selector-title em { font-style: italic; color: var(--gilt-bright); }
      .selector-lead {
        font-family: var(--font-read);
        font-size: 1.05rem; color: var(--vellum-dim); line-height: 1.55;
        max-width: 48ch;
      }

      /* Buscador editorial: regla inferior, sin caja */
      .selector-search-wrap {
        position: relative;
        margin: 36px 0 8px;
        border-bottom: 1px solid var(--gilt-line);
        transition: border-color 0.2s ease;
      }
      .selector-search-wrap:focus-within { border-bottom-color: var(--gilt); }
      .selector-search {
        width: 100%;
        background: transparent;
        border: none; outline: none;
        color: var(--vellum);
        caret-color: var(--gilt);
        font-family: var(--font-read);
        font-size: 1.05rem;
        padding: 10px 10px 10px 30px;
      }
      .selector-search::placeholder { color: var(--vellum-faint); font-style: italic; }
      .selector-search-icon {
        position: absolute; left: 0; top: 50%; transform: translateY(-50%);
        color: var(--gilt); font-size: 1.1rem;
      }

      /* Índice de asignaturas */
      .index-list { list-style: none; margin-top: 8px; }
      @keyframes index-enter { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }
      .index-row {
        position: relative;
        display: grid;
        grid-template-columns: 34px 44px 1fr 24px;
        align-items: center;
        gap: 18px;
        width: 100%;
        text-align: left;
        background: none;
        border: none;
        border-bottom: 1px solid var(--gilt-hair);
        padding: 22px 8px 22px 16px;
        cursor: pointer;
        animation: index-enter 0.5s cubic-bezier(0.16,1,0.3,1) both;
        transition: background 0.22s ease, padding-left 0.28s cubic-bezier(0.16,1,0.3,1);
      }
      /* marcador de acento que crece a la izquierda en hover */
      .index-row::before {
        content: '';
        position: absolute; left: 0; top: 18%; bottom: 18%;
        width: 2px;
        background: var(--row-accent, var(--gilt));
        transform: scaleY(0);
        transform-origin: center;
        transition: transform 0.28s cubic-bezier(0.16,1,0.3,1);
      }
      .index-row:hover {
        background: linear-gradient(90deg, var(--gilt-dim), transparent 60%);
        padding-left: 22px;
      }
      .index-row:hover::before { transform: scaleY(1); }

      .index-folio {
        font-family: var(--font-mono);
        font-size: 0.8rem; color: var(--vellum-faint);
        text-align: right;
      }
      .index-glyph {
        width: 44px; height: 44px;
        display: flex; align-items: center; justify-content: center;
        border: 1px solid var(--gilt-hair);
        border-radius: 10px;
        color: var(--gilt);
        font-size: 1.3rem;
        background: var(--ink-800);
        transition: border-color 0.22s ease, color 0.22s ease;
      }
      .index-row:hover .index-glyph { border-color: var(--row-accent, var(--gilt)); color: var(--row-accent, var(--gilt)); }
      .index-main { min-width: 0; display: flex; flex-direction: column; }
      .index-name, .index-desc { display: block; }
      .index-code {
        display: inline-flex; align-items: center; gap: 7px; align-self: flex-start;
        font-family: var(--font-mono);
        font-size: 0.64rem; letter-spacing: 0.12em; text-transform: uppercase;
        color: var(--vellum-faint);
        margin-bottom: 4px;
      }
      .index-code .dot {
        width: 6px; height: 6px; border-radius: 50%;
        background: var(--row-accent, var(--gilt));
      }
      .index-name {
        font-family: var(--font-display);
        font-optical-sizing: auto;
        font-size: 1.28rem; font-weight: 500;
        color: var(--vellum);
        line-height: 1.2;
        transition: color 0.2s ease;
      }
      .index-row:hover .index-name { color: var(--gilt-bright); }
      .index-desc {
        font-family: var(--font-read);
        font-size: 0.9rem; color: var(--vellum-dim);
        line-height: 1.5; margin-top: 3px;
      }
      .index-arrow {
        color: var(--vellum-faint);
        font-size: 1.1rem;
        transition: transform 0.24s cubic-bezier(0.16,1,0.3,1), color 0.2s ease;
      }
      .index-row:hover .index-arrow { color: var(--gilt); transform: translateX(4px); }

      .selector-empty { text-align: center; padding: 56px 0; }
      .selector-empty-mark {
        width: 64px; height: 64px;
        display: flex; align-items: center; justify-content: center;
        border: 1px solid var(--gilt-line); border-radius: 14px;
        background: var(--ink-800);
        margin: 0 auto 18px;
        color: var(--gilt); font-size: 1.5rem;
      }
      .selector-empty p { font-family: var(--font-read); color: var(--vellum-dim); font-size: 1rem; }

      @media (max-width: 768px) {
        .selector-wrap { padding: 40px 18px; }
        .index-row { grid-template-columns: 26px 1fr 20px; gap: 12px; }
        .index-glyph { display: none; }
      }
    `}</style>
  );
}

interface SubjectSelectorProps {
  onSelectSubject: (subject: string) => void;
}

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

export default function SubjectSelector({ onSelectSubject }: SubjectSelectorProps) {
  void SUBJECTS;
  const [searchTerm, setSearchTerm] = useState('');
  const filteredSubjects = searchSubjects(searchTerm);

  return (
    <>
      <SubjectSelectorStyles />
      <div className="selector-wrap">
        <div className="selector-col">
          <p className="selector-eyebrow">Códice · Índice</p>
          <h2 className="selector-title">
            Abre una <em>materia</em>
          </h2>
          <p className="selector-lead">
            Elige la asignatura sobre la que quieres trabajar. Minerva responderá citando sus
            fuentes y te propondrá preguntas para seguir profundizando.
          </p>

          <div className="selector-search-wrap">
            <i className="ri-search-line selector-search-icon" />
            <input
              type="text"
              className="selector-search"
              placeholder="Buscar entre las asignaturas…"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {filteredSubjects.length > 0 ? (
            <ul className="index-list">
              {filteredSubjects.map((subject, index) => (
                <li key={subject.id}>
                  <button
                    type="button"
                    className="index-row"
                    style={{
                      ['--row-accent' as string]: subject.accentColor,
                      animationDelay: `${index * 0.06}s`,
                    }}
                    onClick={() => onSelectSubject(subject.name)}
                  >
                    <span className="index-folio">{ROMAN[index] ?? index + 1}</span>
                    <span className="index-glyph">
                      <i className={subject.icon} />
                    </span>
                    <span className="index-main">
                      <span className="index-code">
                        <span className="dot" />
                        {subject.code}
                      </span>
                      <span className="index-name">{subject.name}</span>
                      <span className="index-desc">{subject.description}</span>
                    </span>
                    <i className="ri-arrow-right-line index-arrow" />
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <div className="selector-empty">
              <div className="selector-empty-mark">
                <i className="ri-search-line" />
              </div>
              <p>No hay asignaturas que coincidan con tu búsqueda.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
